import { createContext } from 'react';
import type { LinkingOrigin } from '../../linkingOrigin';

/**
 * De qué superficie salió ESTE montaje del flujo de vinculación, disponible
 * para todo emisor de tracking que cuelgue de él.
 *
 * El `origin` ya era una prop requerida de `LinkingFlow`, pero sólo viajaba en
 * el FormData del bind: terminaba en `link_attempt.metadata.origin` y jamás en
 * un evento del front, así que el embudo no se podía cortar por pantalla. Los
 * nueve emisores de `useLinkingTracking` (selector, credenciales, drawers de
 * ayuda, espera, orquestador) están repartidos por todo el árbol; pasarlo como
 * prop obligaba a atravesar componentes que no lo usan y dejaba abierta la
 * puerta a que un emisor nuevo lo olvidara y emitiera sin superficie.
 *
 * `null` es el valor de quien emite fuera de `LinkingFlow` sin declarar su
 * superficie: así queda visible en el dato. Quien emite fuera a propósito (el
 * host de onboarding v3) la declara con `useLinkingTracking(origin)`.
 */
export const LinkingOriginContext = createContext<LinkingOrigin | null>(null);
